import React from 'react';
import classNames from 'classnames';
import Typography from 'Components/atoms/Typography/Typography';
import './styles.scss';

interface StatTileProps {
    label: string;
    value: React.ReactNode;
    /** Small caption under the value, e.g. "Matching planned". */
    hint?: string;
    icon?: React.ReactNode;
    /** Renders the tile as a reserved / not-yet-available metric. */
    muted?: boolean;
}

/** A compact KPI tile: a small uppercase label above a large value. */
const StatTile: React.FC<StatTileProps> = ({ label, value, hint, icon, muted }) => (
    <div className={classNames('rb-stat-tile', muted && 'rb-stat-tile--muted')}>
        <div className="rb-stat-tile__head">
            {icon && <span className="rb-stat-tile__icon">{icon}</span>}
            <Typography variant="overline" color="text-low-emphasis" className="rb-stat-tile__label">
                {label}
            </Typography>
        </div>
        <div className="rb-stat-tile__value">{value}</div>
        {hint && (
            <Typography variant="caption2" color="text-low-emphasis" className="rb-stat-tile__hint">
                {hint}
            </Typography>
        )}
    </div>
);

export default StatTile;
